/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbBooleanLogicTreeContext } from "abreact/incubator/ui/abBooleanLogicTree/AbBooleanLogicTreeContext";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbMenuButton } from "abreact/menu/AbMenuButton";
import { AB_ITEM_SEPARATOR } from "abweb/collection/AbItemSeparator";
import { NullUtils } from "abweb/utils/NullUtils";
import * as React from "react";

/** Refactored to use modern absdk popup + be a functional component 2/12/24 **/

export const SingleRowActionsMenu = props => {
  const context = NullUtils.assertDefined(React.useContext(AbBooleanLogicTreeContext));
  const {
    level,
    isFirstItem,
    isLastItem
  } = props;
  const canDeleteRow = context.canDeleteRow ? context.canDeleteRow(level, isFirstItem, isLastItem) : true;
  const canGroupWithNext = context.canGroupWithNext ? context.canGroupWithNext(level, isFirstItem, isLastItem) : true;
  const classNames = ReactUtils.classNamesString(["ab-no-border-button"]);
  const computeDataTestId = suffix => {
    return props.dataTestIdGenerator != null ? props.dataTestIdGenerator.generateID(props.conditionKey, suffix) : suffix;
  };
  const dataTestId = computeDataTestId("row-actions-menu");
  let menuItems = [{
    label: AbReactResources.abBooleanLogicTree_menu_moveUp(),
    onClick: () => props.onMoveUp(),
    disabled: props.isFirstItem,
    dataTestId: computeDataTestId("move-up"),
    className: "ab-no-border-button"
  }, {
    label: AbReactResources.abBooleanLogicTree_menu_moveDown(),
    onClick: () => props.onMoveDown(),
    disabled: props.isLastItem,
    dataTestId: computeDataTestId("move-down"),
    className: "ab-no-border-button"
  }, AB_ITEM_SEPARATOR];
  if (props.supportsSubgroups !== false) {
    menuItems = menuItems.concat([{
      label: AbReactResources.abBooleanLogicTree_menu_makeIntoGroup(),
      onClick: () => props.onMakeSubGroupClicked(),
      disabled: false,
      dataTestId: computeDataTestId("convert-to-subcondition"),
      className: "ab-no-border-button"
    }, {
      label: props.rowLanguageSource.groupWithNextRowLabel,
      onClick: () => props.onGroupWithNext(),
      disabled: !canGroupWithNext,
      dataTestId: computeDataTestId("group-with-next"),
      className: "ab-no-border-button"
    }, AB_ITEM_SEPARATOR]);
  }
  menuItems = menuItems.concat([{
    label: AbReactResources.abBooleanLogicTree_menu_duplicate(),
    onClick: () => props.onDuplicate(),
    disabled: false,
    dataTestId: computeDataTestId("duplicate"),
    className: "ab-no-border-button"
  }, {
    label: AbReactResources.abBooleanLogicTree_menu_insertAbove(),
    onClick: () => props.onInsertAbove(),
    disabled: false,
    dataTestId: computeDataTestId("insert-above"),
    className: "ab-no-border-button"
  }, {
    label: AbReactResources.abBooleanLogicTree_menu_insertBelow(),
    onClick: () => props.onInsertBelow(),
    disabled: false,
    dataTestId: computeDataTestId("insert-below"),
    className: "ab-no-border-button"
  }]);
  if (props.serverSupportsDisabledConditionSection) {
    menuItems = menuItems.concat([{
      label: AbReactResources.abBooleanLogicTree_menu_enableCondition(),
      onClick: () => props.onEnable(),
      disabled: !props.isConditionDisabled,
      dataTestId: computeDataTestId("enable-condition"),
      className: "ab-no-border-button"
    }, {
      label: AbReactResources.abBooleanLogicTree_menu_disableCondition(),
      onClick: () => props.onDisable(),
      disabled: props.isConditionDisabled,
      dataTestId: computeDataTestId("disable-condition"),
      className: "ab-no-border-button"
    }, AB_ITEM_SEPARATOR]);
  }
  menuItems.push({
    label: props.rowLanguageSource.deleteRowLabel,
    onClick: () => props.onDeleteClicked(),
    disabled: !canDeleteRow,
    dataTestId: computeDataTestId("delete-condition")
  });
  return /*#__PURE__*/React.createElement(AbMenuButton, {
    className: classNames,
    disabled: props.isReadonly,
    dataTestId: `${dataTestId}-button`,
    icon: "absdk:more",
    menuItems: menuItems,
    menuProps: {
      dataTestId
    }
  });
};
//# sourceMappingURL=SingleRowActionsMenu.js.map
